import { SnippetsOutlined } from "@ant-design/icons"
import { Card } from "antd"
import React from "react"
import { t } from "~/languages/i18n"
import { PageData } from "~/types/types"
interface Card3Props {
  setLoading: (loading: boolean) => void
  loading: boolean
  latestPages: PageData[]
  handleLearnMore: () => void
  setDraggedCardId: (id: number | null) => void
}

const Card3: React.FC<Card3Props> = ({ setLoading, loading, latestPages, handleLearnMore, setDraggedCardId }) => {
  const totalPages = latestPages.length
  const draftPages = latestPages.filter(page => page.attributes.publishedAt === null).length
  const publishedPages = latestPages.filter(page => page.attributes.publishedAt != null).length

  return (
    <Card loading={loading} className="shadow-lg mb-2 p-4 h-[200px]" draggable onDragStart={() => setDraggedCardId(3)}>
      <div className="">
        <div className="flex justify-between flex-col gap-2">
          <div>
            <div className="flex justify-between items-center">
              <div className="flex">
                <SnippetsOutlined className="mr-2 text-2xl" />
                <span className="font-semibold text-3xl mr-2">{t("Pages")}</span>
              </div>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="1.5"
                stroke="currentColor"
                className="size-6"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M13.5 6H5.25A2.25 2.25 0 0 0 3 8.25v10.5A2.25 2.25 0 0 0 5.25 21h10.5A2.25 2.25 0 0 0 18 18.75V10.5m-10.5 6L21 3m0 0h-5.25M21 3v5.25"
                />
              </svg>
            </div>
          </div>
          <p className="font-normal text-xl">
            {t("All")}: {totalPages}{" "}
          </p>
          <p className="font-normal text-xl">
            {t("Publish")}: {publishedPages}
          </p>
          <p className="font-normal text-xl">
            {t("Draft")}: {draftPages}
          </p>
        </div>
      </div>
    </Card>
  )
}

export default Card3
